export { FileInput } from "@mantine/core";
export type { FileInputProps } from "@mantine/core";
export { fileInputOverrides } from "./FileInput.config";
